import { useMemo } from 'react'

import {
  getAchievementScoreRows,
  getAchievementScoreScores,
  IRevenueAndSobCategoryRow,
} from 'partner360/features/financialCockpit/lib'

export const useAchievementScoreRows = (rows: IRevenueAndSobCategoryRow[]) => {
  const achievementScoreRows = useMemo(() => getAchievementScoreRows(rows), [rows])
  const achievementScoreScores = useMemo(
    () => getAchievementScoreScores(achievementScoreRows),
    [achievementScoreRows]
  )

  return { achievementScoreScores }
}
